export default class PopupConstants { 
    static CHCKMARK_FOR_POPUP: string = "✔";
    static CRSSMARK_FOR_POPUP: string = "❌";
}